import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import FormField from "../../Helpers/FormField";
import {checkbox, input} from "../../../utils/linker";

function Bool(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  console.log("BOOL VAL", props.code, props.linker.value, typeof props.linker.value);

  return (
    <div>
      <FormField input_id={`chk_${props.code}`} title={props.option.name} type="checkbox" description={props.option.description}>
        <input id={`chk_${props.code}`} type="checkbox" {...checkbox(props.linker, "value")} />
      </FormField>
    </div>
  )
};

Bool.defaultProps = {};

Bool.propTypes = {}

export default observer(Bool);
